import { format } from 'date-fns';
import { type ReactElement } from 'react';
import { TimeElement } from '../../TimeElement/TimeElement';
import { capitalizeFirstLetter } from '../../Util';
import formatCloseRelative from '../../Util/formatCloseRelative';
import type { ClusteredMarkerLayerOptions } from '../Layers/Layers.types';
import { type ShuttleParkingProperties } from '../Sources/ParkingsGbg/ShuttleParkingsSource';
import PopupTemplateWrapper from './PopupTemplateWrapper';

export default function ShuttleParkingGbg(properties: ShuttleParkingProperties, layerOptions: ClusteredMarkerLayerOptions): ReactElement {
    console.table(properties);
    return (
        <PopupTemplateWrapper iconId={208} title={layerOptions.name}>
            <div className="">
                <h3>{properties.name}</h3>
                <table>
                    <tbody>
                        {properties.freeSpaces !== null && (
                            <tr>
                                <td>Lediga platser:</td>
                                <td>{properties.freeSpaces}</td>
                            </tr>
                        )}
                        {properties.parkingSpaces != null && (
                            <tr>
                                <td>Antal platser:</td>
                                <td>{properties.parkingSpaces}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <div className="popup-details flex">
                    <dl>
                        {properties.updated != null && (
                            <>
                                <dt>Uppdaterad:</dt>
                                <dd title={properties.updated ? format(properties.updated, 'Pp') : ''}>
                                    {properties.updated ? (
                                        <TimeElement date={properties.updated}>
                                            {capitalizeFirstLetter(formatCloseRelative(properties.updated))}
                                        </TimeElement>
                                    ) : (
                                        'Ingen uppgift'
                                    )}
                                </dd>
                            </>
                        )}
                        <dt>Källa:</dt>
                        <dd>{properties.provider}</dd>
                    </dl>
                </div>
                <div className="d-flex justify-content-end mt-1">
                    <div id="popup-favorite-toggler" />
                </div>
            </div>
        </PopupTemplateWrapper>
    );
}
